export function splitStringByComma(val: string) {
  return val.split(',').filter((item) => item.length);
}
